"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const Table_1 = tslib_1.__importDefault(require("@material-ui/core/Table"));
const TableBody_1 = tslib_1.__importDefault(require("@material-ui/core/TableBody"));
const TableCell_1 = tslib_1.__importDefault(require("@material-ui/core/TableCell"));
const TableContainer_1 = tslib_1.__importDefault(require("@material-ui/core/TableContainer"));
const TableHead_1 = tslib_1.__importDefault(require("@material-ui/core/TableHead"));
const TableRow_1 = tslib_1.__importDefault(require("@material-ui/core/TableRow"));
const Paper_1 = tslib_1.__importDefault(require("@material-ui/core/Paper"));
const core_1 = require("@material-ui/core");
const react_spinners_1 = require("react-spinners");
function DataTable(props) {
    const { csvData, hideNoColumn } = props;
    const [loading, setLoading] = react_1.useState(true);
    const cellStyle = {};
    const classes = useStyles();
    const headers = csvData && csvData.length > 0 ? Object.keys(csvData[0]) : [];
    react_1.useEffect(() => {
        if (csvData && csvData.length > 0) {
            setLoading(false);
        }
    }, [csvData]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        loading && (react_1.default.createElement("div", { style: {
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(128, 128, 128, 0.7)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999
            } },
            react_1.default.createElement(react_spinners_1.PropagateLoader, { color: "#3f51b5" }))),
        react_1.default.createElement(Paper_1.default, { className: classes.root },
            react_1.default.createElement(TableContainer_1.default, { className: classes.tableContainer },
                react_1.default.createElement(Table_1.default, { stickyHeader: true, "aria-label": "sticky table" },
                    react_1.default.createElement(TableHead_1.default, null,
                        react_1.default.createElement(TableRow_1.default, null,
                            !hideNoColumn && csvData && (react_1.default.createElement(TableCell_1.default, { style: Object.assign({}, cellStyle, { fontWeight: "bold", position: "sticky", top: 0, backgroundColor: "white", zIndex: 1, color: "#324054" }), align: "left" }, "No")),
                            headers.map((header, index) => (react_1.default.createElement(TableCell_1.default, { key: header, style: Object.assign({}, cellStyle, { fontWeight: "bold", position: "sticky", top: 0, backgroundColor: "white", zIndex: 1, color: "#324054" }), align: headers[index].toLowerCase() == 'graph' ? "right" : "left" }, header.replace(/_/g, ' ').charAt(0).toUpperCase() + header.replace(/_/g, ' ').slice(1)))))),
                    react_1.default.createElement(TableBody_1.default, null, csvData && csvData.map((row, rowIndex) => (react_1.default.createElement(TableRow_1.default, { key: rowIndex },
                        !hideNoColumn && (react_1.default.createElement(TableCell_1.default, { style: Object.assign({}, cellStyle, { backgroundColor: rowIndex % 2 == 0 ? '#F5F5F5' : 'white', color: "#324054" }), align: "left" }, rowIndex + 1)),
                        headers.map((header, index) => (react_1.default.createElement(TableCell_1.default, { key: header, style: Object.assign({}, cellStyle, { backgroundColor: rowIndex % 2 == 0 ? '#F5F5F5' : 'white', color: "#324054" }), align: headers[index].toLowerCase() == 'graph' ? "right" : "left", onClick: () => header == 'Graph' ? props.handleGraphView(rowIndex) : null }, react_1.default.isValidElement(row[header]) ? row[header] : row[header].toString()))))))))))));
}
exports.default = DataTable;
const useStyles = core_1.makeStyles({
    root: {
        width: '100%',
    },
    tableContainer: {
        maxHeight: 500,
    },
});
//# sourceMappingURL=data-table.js.map